import { MagicTextBoxEditorTab } from '@/components/ContentTreeNode/ContentTreeLeafNode/MagicTextBoxEditor/MagicTextBoxEditor.types'
import { atom } from 'recoil'

export const activeMTBEditorTabAtom = atom<MagicTextBoxEditorTab>({
    key: 'activeMTBEditorTabAtom',
    default: MagicTextBoxEditorTab.editable,
})
